import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import * as Utils from "./Utils";
import iconUser from "../img/icons/icon-user.svg";
import iconDocument from "../img/icons/icon-document.svg";
import iconClipboard from "../img/icons/icon-clipboard.svg";
import { jwtDecode } from "jwt-decode";

export default function MemberSidebar(prop) {
    let navigate = useNavigate();

    let [member, setMember] = React.useState(null);

    React.useEffect(() => {
        let memberTokens = localStorage.getItem(Utils.LOCAL_STORAGE_KEY);
        if(memberTokens) {
            let memberJson = jwtDecode(JSON.parse(memberTokens).accessToken);
            setMember(memberJson);
            let checkExpireHrs = (Math.abs(new Date().getTime() - new Date(memberJson.latestLoginAt).getTime()) / 3600000);
            if(checkExpireHrs > Utils.HOURS_EXPIRE_LOGIN) {
                navigate((prop.lang === 'en' ? '/en':'/') + 'login');
            }
        }
        else {
            window.location.href = (prop.lang === 'en' ? '/en':'/') + 'login';
        }
    }, []);

    const logOut = () => {
        localStorage.removeItem(Utils.LOCAL_STORAGE_KEY);
        window.location.href = '/';
    };

    return (
        <>
            <ul className="nav nav-sidebar" data-aos="fade-in">
                <li className={prop.active === 'profile' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/profile':'/profile'}><img className="icons svg-js" src={iconUser} alt="" /> {prop.lang === 'en' ? 'Profile':'ข้อมูลส่วนตัว'}</NavLink>
                </li>
                <li className={prop.active === 'changePassword' ? "active" : ''}>
                    <NavLink to={prop.lang === 'en' ? '/en/changePassword':'/changePassword'}><img className="icons svg-js" src={iconUser} alt="" /> {prop.lang === 'en' ? 'Change Password':'เปลี่ยนรหัสผ่าน'}</NavLink>
                </li>

                {
                    member && member.typeId === Utils.MEMBER_TYPE_RESEARCHER ?
                        <>
                            <li className={prop.active === 'scholarship' ? "active" : ''}>
                                <NavLink to={prop.lang === 'en' ? '/en/scholarship':'/scholarship'}><img className="icons svg-js" src={iconDocument} alt="" /> {prop.lang === 'en' ? 'Open Research':'ทุนวิจัยที่เปิดรับ'}</NavLink>
                            </li>
                            <li className={prop.active === 'proposal' ? "active" : ''}>
                                <NavLink to={prop.lang === 'en' ? '/en/proposal':'/proposal'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Project Proposal':'ข้อเสนอโครงการ'}</NavLink>
                            </li>
                            <li className={prop.active === 'approve' ? "active" : ''}>
                                <NavLink to={prop.lang === 'en' ? '/en/proposalApprove':'/proposalApprove'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Approval Projects':'โครงการที่ได้รับจัดสรร'}</NavLink>
                            </li>
                            <li className={prop.active === 'result' ? "active" : ''}>
                                <NavLink to={prop.lang === 'en' ? '/en/proposalResult':'/proposalResult'}><img className="icons svg-js" src={iconClipboard} alt="" /> {prop.lang === 'en' ? 'Report Results':'รายงานผลลัพธ์'}</NavLink>
                            </li>
                        </> : ''
                }

                {
                    member && member.typeId === Utils.MEMBER_TYPE_BUSINESS ?
                    <>
                        <li className={prop.active === 'businessInfo' ? "active" : ''}>
                            <NavLink to={prop.lang === 'en' ? '/en/businessInfo':'/businessInfo'}><img className="icons svg-js" src={iconDocument} alt="" /> {prop.lang === 'en' ? 'Business Info':'ข้อมูลบริษัท'}</NavLink>
                        </li>
                        <li className={prop.active === 'businessForm' ? "active" : ''}>
                            <NavLink to={prop.lang === 'en' ? '/en/businessForm':'/businessForm'}><img className="icons svg-js" src={iconDocument} alt="" /> {prop.lang === 'en' ? 'Business Quality Form':'ยื่นคำร้องขอรับรองคุณภาพฯ'}</NavLink>
                        </li>
                        <li className={prop.active === 'businessProduct' ? "active" : ''}>
                            <NavLink to={prop.lang === 'en' ? '/en/businessProduct':'/businessProduct'}><img className="icons svg-js" src={iconDocument} alt="" /> {prop.lang === 'en' ? 'Products & Services':'สินค้าและบริการ'}</NavLink>
                        </li>
                    </> : ''
                }

                <li className={prop.active === 'logout' ? "active" : ''}>
                    <a href="#" onClick={logOut}><img className="icons svg-js" src={iconUser} alt="" /> {prop.lang === 'en' ? 'Logout':'ออกจากระบบ'}</a>
                </li>
            </ul>

            <p className="text-center mt-4">
                <NavLink className="btn btn-xs btn-gray w-50 m-auto" to={prop.lang === 'en' ? '/en/deleteAccount':'/deleteAccount'}>
                    {prop.lang === 'en' ? 'Delete Account':'ลบบัญชี'}
                </NavLink>
            </p>
        </>
    );
} 